   <template>
   	<div id="previewControls">
       <div id="previewbar">
            <nav class="navbar navbar-light flex justify-center">
              <form class="btn-group mx-auto">
                
                <button class="btn btn-outline-primary" @click="prev()" type="button">Previous Card</button>
                
                <button class="btn btn-outline-primary" @click="next()" type="button">Next Card</button> 

              </form>
            </nav>
        </div>
   	</div>

    
	
</template>
<script>
    export default {
        mounted() {
            
        },
        props: [
            
        ],
        methods: {
            prev: function(){
                
                document.getElementById('deckPreviewIframe').contentWindow.postMessage('triggerPrev');

            },
            next: function(){
                
                document.getElementById('deckPreviewIframe').contentWindow.postMessage('triggerNext');

            }
        }
    }
</script>
<style type="text/css">
    #previewControls.hidden{
        display: none;
    }
</style>
